export type ReaderConsoleConnection = {
  status: 'unavailable';
  message: string;
};

/**
 * Deliberate integration seam for the pending reader-log WebSocket service.
 * No network connection is attempted until the backend endpoint is available.
 */
export const connectReaderLiveConsole = async (_readerId: string): Promise<ReaderConsoleConnection> => ({
  status: 'unavailable',
  message: 'Live reader streaming is not available yet.',
});
